












import Vue from 'vue'
import QboConnection from '@/components/QboConnection.vue'
import QboSync from '@/components/QboSync.vue'
export default Vue.extend({
    components: { QboConnection, QboSync },
    data() {
        return {
            toolbar: {
                title: 'QuickBooks Online',
                left: [
                    {
                        title: 'Back',
                        icon: 'mdi-chevron-left',
                        back: '/settings',
                        tooltip: 'Back'
                    }
                ],
                right: []
            }
        }
    },
    methods: {
        goToQbo(): void {
            //  Grab our url from the .env
            const url = process.env.VUE_APP_QBO_APP_URL

            //  Open up the url
            window.open(url, this.$store.getters.isApp ? '_system' : '_blank')
        }
    }
})
